import { useAmazonBookSearchBase } from './useAmazonBookSearchBase'

export const useAmazonBookSearch = () => {
  return useAmazonBookSearchBase({
    initialSortDecision: 'scan'
  })
}
